<template>
    <div>
        <h1>{{ $t("blocks.heading") }}</h1>
        <router-link :to="{ name: 'createBlock' }" class="btn btn-primary">{{ $t("utils.create") }}</router-link>
        <table class="table">
            <tr>
                <th>{{ $t("blocks.id") }}</th>
                <th>{{ $t("blocks.name") }}</th>
                <th>{{ $t("blocks.actions") }}</th>
            </tr>
            <tr v-for="(block, i) in blocks">
                <td>{{ block.block_id }}</td>
                <td>{{ block.name }}</td>
                <td>
                    <router-link :to="{ name: 'block', params: {id: block.id} }" class="btn btn-primary me-2">{{ $t("utils.detail") }}</router-link>
                    <button class="btn btn-primary" @click="hide(block.id)">{{ $t("utils.delete") }}</button>
                </td>
            </tr>
        </table>
    </div>
</template>


<script>
export default {
    data() {
        return {
            blocks: [],
            loading: false
        }
    },
    created: function () {
        this.loadData();
    },
    methods: {
        loadData: function () {
            this.loading = true;
            this.$store.getters.api.get("/blocks").then(function (response) {
                this.blocks = response.data.data;
                this.loading = false;
            }.bind(this))
        },
        hide: function (id) {
            this.$store.getters.api.post("/block/" + id +"/hide").then(function (response) {
                this.loadData();
            }.bind(this))
        }
    }
}
</script>
<style lang="scss">
</style>
